import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    dashboards: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_DASHBOARDS_SELECT_IDS (store, ids) {
      store.dashboards.selectIds = ids
    },
    REMOVE_DASHBOARD_SELECT_IDS (store, ids) {
      store.dashboards.selectIds = store.dashboards.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_DASHBOARDS_SELECT_ID (store, id) {
      store.dashboards.selectId = id
    },
    SET_DASHBOARDS_FILTERS (store, filters) {
      store.dashboards.filters = filters
    },
    SET_DASHBOARDS_PAGINATE (store, val) {
      store.dashboards.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getDashboards: (store, getters) => {
      return store.dashboards.selectIds.map((id) => {
        return getters['entities/dashboards/find'](id)
      })
    },
    getDashboardsFilters: (store, getters) => {
      return store.dashboards.filters
    },
    getDashboardsPaginate: (store, getters) => {
      return store.dashboards.paginate
    },
    getDashboard: (store, getters) => {
      return getters['entities/dashboards/find'](store.dashboards.selectId) || {}
    }
  },
  actions: {
    /*
    selectDashboards
    */
    selectDashboards ({commit, dispatch, getters, state}, filters) {
      return dispatch('getDashboards', filters)
      .then((response) => {
        commit('SET_DASHBOARDS_FILTERS', filters)
        commit('SET_DASHBOARDS_PAGINATE', response)
        commit('SET_DASHBOARDS_SELECT_IDS', response.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectDashboards
    */
    refreshSelectDashboards ({commit, dispatch, getters, state}) {
      return dispatch('selectDashboards', getters.getDashboardsFilters)
    },
    /*
    selectDashboard
    */
    selectDashboard ({commit, dispatch, getters, state}, id) {
      return dispatch('getDashboardById', id)
      .then((response) => {
        commit('SET_DASHBOARDS_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getDashboards
    */
    getDashboards ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/dashboards`, {params: filters})
      .then((response) => {
        return dispatch('entities/dashboards/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.dashboards || []
      })
    },
    /*
    getDashboardById
    */
    getDashboardById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/dashboards/${id}`)
      .then((response) => {
        return dispatch('entities/dashboards/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.dashboards[0]
      })
    },
    /*
    createDashboard
    */
    createDashboard ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/dashboards`, data)
      .then((response) => {
        return dispatch('entities/dashboards/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.dashboards[0]
      })
    },
    /*
    updateDashboard
    */
    updateDashboard ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/dashboards/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/dashboards/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.dashboards[0]
      })
    },
    /*
    deleteDashboard
    */
    deleteDashboard ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/dashboards/${id}`)
      .then((response) => {
        commit('REMOVE_DASHBOARD_SELECT_IDS', [id])
        dispatch('entities/dashboards/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Dashboard.js